class CollectionsShowcase extends HTMLElement {
  constructor() {
    super();
    this.swipers = [];
    this.waitingForSwiper = null;
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.teardown();
    if (this.waitingForSwiper) {
      clearInterval(this.waitingForSwiper);
      this.waitingForSwiper = null;
    }
  }

  init() {
    if (typeof window.Swiper === "undefined") {
      this.waitForSwiper();
      return;
    }

    this.teardown();
    this.buildSliders();
  }

  waitForSwiper() {
    if (this.waitingForSwiper) return;

    this.waitingForSwiper = setInterval(() => {
      if (typeof window.Swiper !== "undefined") {
        clearInterval(this.waitingForSwiper);
        this.waitingForSwiper = null;
        this.init();
      }
    }, 120);
  }

  buildSliders() {
    const sliderEls = this.querySelectorAll(".gift-collections-slider__swiper");
    sliderEls.forEach((sliderEl) => {
      const slidesDesktop = Math.max(
        1,
        parseInt(sliderEl.dataset.slidesDesktop || sliderEl.dataset.slidesPerViewDesktop, 10) || 4
      );
      const slidesTablet = Math.max(
        1,
        parseInt(sliderEl.dataset.slidesTablet || sliderEl.dataset.slidesPerViewTablet, 10) || 2
      );
      const slidesMobile = Math.max(
        1,
        parseInt(sliderEl.dataset.slidesMobile || sliderEl.dataset.slidesPerViewMobile, 10) || 1
      );
      const gapDesktop = parseInt(
        sliderEl.dataset.gapDesktop || sliderEl.dataset.slidesGapDesktop,
        10
      );
      const gapTablet = parseInt(
        sliderEl.dataset.gapTablet || sliderEl.dataset.slidesGapTablet,
        10
      );
      const gapMobile = parseInt(
        sliderEl.dataset.gapMobile || sliderEl.dataset.slidesGapMobile,
        10
      );

      const spaceDesktop = Number.isFinite(gapDesktop) ? gapDesktop : 16;
      const spaceTablet = Number.isFinite(gapTablet) ? gapTablet : spaceDesktop;
      const spaceMobile = Number.isFinite(gapMobile) ? gapMobile : spaceTablet;

      const swiper = new Swiper(sliderEl, {
        slidesPerView: slidesDesktop,
        spaceBetween: spaceDesktop,
        speed: 450,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          0: { slidesPerView: slidesMobile, spaceBetween: spaceMobile },
          768: { slidesPerView: slidesTablet, spaceBetween: spaceTablet },
          1024: { slidesPerView: slidesDesktop, spaceBetween: spaceDesktop }
        }
      });

      this.swipers.push(swiper);
    });
  }

  teardown() {
    if (!this.swipers.length) return;
    this.swipers.forEach((swiper) => swiper.destroy(true, true));
    this.swipers = [];
  }

  refresh() {
    this.init();
  }
}

if (!customElements.get("s-collections-showcase")) {
  customElements.define("s-collections-showcase", CollectionsShowcase);
}

document.addEventListener("shopify:section:load", (event) => {
  event.target
    .querySelectorAll("s-collections-showcase")
    .forEach((element) => element.refresh && element.refresh());
});

document.addEventListener("shopify:section:unload", (event) => {
  event.target
    .querySelectorAll("s-collections-showcase")
    .forEach((element) => element.teardown && element.teardown());
});
